import React, { useEffect, useState } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useInfiniteQuery } from 'react-query';
import { useHistory } from 'react-router-dom';

import {
  Box,
  Grid,
  LinearProgress,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  createStyles,
  makeStyles,
  useMediaQuery,
  useTheme,
} from '@material-ui/core';
import Fade from '@material-ui/core/Fade';

import DenunciasIlus from '../../../../../assets/img/denuncias.png';
import { ReactComponent as RightIcon } from '../../../../../assets/img/icon/Right.svg';
import redCheckImg from '../../../../../assets/img/red_point.png';
import SubHeader from '../../../../../components/Header/SubHeader.component';
import Loader from '../../../../../components/LoaderSplash/Loader.component';
import { appConfig } from '../../../../../config/app';
import { CustomEvents } from '../../../../../constants/analytics.constant';
import { IncidentsLabels } from '../../../../../constants/incidents.constant';
import { useAuthDataContext } from '../../../../../context/auth/auth.provider';
import { useIncidentsContext } from '../../../../../context/incidents/incidents.provider';
import { dataLayerPush } from '../../../../../helpers/dataLayerPush';
import useLogEventInAnalytics from '../../../../../hooks/useLogAnalyticsEvent';
import {
  SINISTER_INSPECTION_QUERY,
  sinisterInspectionsQuery,
} from '../../../../../query/sinisterInspections/sinisterInspections';

const useStyle = makeStyles(() =>
  createStyles({
    incidentsImg: {
      width: '20%',
      maxWidth: '500px',
      minWidth: '150px',
    },
    card: {
      height: '100%',
      '& a': {
        height: '100%',
      },
      '& div': {
        height: '100%',
      },
    },
  })
);

const ListIncidents = () => {
  const classes = useStyle();
  const history = useHistory();
  const { user } = useAuthDataContext();
  const { getIncidentById } = useIncidentsContext();
  const [page, setPage] = useState(1);
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down('sm'));
  const { logEvent } = useLogEventInAnalytics();
  let lastPageEmpty = 0;

  const {
    data: incidents,
    isLoading: loading,
    fetchNextPage,
    hasNextPage: next,
  } = useInfiniteQuery(SINISTER_INSPECTION_QUERY, sinisterInspectionsQuery, {
    getNextPageParam: (lastPage) => {
      lastPageEmpty = lastPage.length;
    },
  });

  useEffect(() => {
    dataLayerPush('Cuenta_mis_denuncias', user?.id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    logEvent(CustomEvents.COMPLAINTS_VIEW, {
      app: appConfig?.NAME,
    });
  }, [logEvent]);

  const selectedIncidentByID = async (id, status) => {
    await getIncidentById(id);
    if (status === 'Inspección coordinada') {
      history.push(`/coordinated-inspection/${id}`);
    } else {
      history.push('/sinister-method');
    }
  };

  const handleNextPage = () => {
    fetchNextPage({ pageParam: page + 1 });
    setPage((prev) => prev + 1);
  };

  const HandleMore = () => {
    // Robustecer validación para detectar si hace falta cargar más registros o no.

    // Según lo consultado con BE, el paginado se realiza de a 20 registros por vez, por lo que para poder mostrar
    // un scroll infinito tendría que hacerce de a 20 registros por vez.
    let val =
      lastPageEmpty > 0 && incidents?.pages?.flat().length >= 20 ? true : false;
    return val;
  };

  return (
    <>
      <Box display={loading || !incidents?.pages ? 'block' : 'none'}>
        <Loader action={'Cargando denuncias'}></Loader>
      </Box>

      <SubHeader
        content={
          <Box>
            <Typography variant="h6">Coordinar una inspección</Typography>
          </Box>
        }
      ></SubHeader>

      {incidents?.pages && (
        <Grid container justify="center">
          <Grid item xs={11}>
            <Grid container>
              <Box mt={3} mb={2}>
                <Typography variant="h6" color="textPrimary">
                  Mis denuncias
                </Typography>
              </Box>

              <Grid item xs={12}>
                {matches ? (
                  <div
                    id="scrollableDiv"
                    style={{
                      height: 600,
                      overflow: 'auto',
                    }}
                  >
                    <InfiniteScroll
                      //This is important field to render the next data
                      dataLength={incidents?.pages?.flat().length}
                      next={handleNextPage}
                      hasMore={HandleMore()}
                      loader={
                        <Box style={{ width: '100%' }}>
                          <LinearProgress color="primary" />
                        </Box>
                      }
                      endMessage={
                        <Box m={2}>
                          <Typography
                            style={{ textAlign: 'center' }}
                            color="textSecondary"
                          >
                            Ya hemos mostrado todos los resultados
                          </Typography>
                        </Box>
                      }
                      // height={matches ? 600 : null}
                      scrollableTarget={'scrollableDiv'}
                    >
                      <>
                        {incidents && !incidents?.pages?.flat().length ? (
                          <Box my={4} textAlign="center">
                            {/* <img
                              className={classes.incidentsImg}
                              src={DenunciasIlus}
                              alt={'Denuncias'}
                            ></img> */}
                            <Typography variant="h6">
                              {' '}
                              ¡No tenés denuncias!{' '}
                            </Typography>
                            <Typography variant="body2">
                              {' '}
                              Cuando realices una denuncia vas a poder darle
                              seguimiento desde acá.{' '}
                            </Typography>
                          </Box>
                        ) : (
                          <Box my={2}>
                            <TableContainer component={Paper}>
                              <Table aria-label="incidents table">
                                <TableHead>
                                  <TableRow>
                                    <TableCell> Denuncia </TableCell>
                                    <TableCell align="center">
                                      {' '}
                                      Patente{' '}
                                    </TableCell>
                                    <TableCell align="center"> </TableCell>
                                  </TableRow>
                                </TableHead>
                                <TableBody>
                                  {incidents?.pages
                                    ?.flat()
                                    .map((incident: any) => (
                                      <Fade in={true}>
                                        <TableRow
                                          hover
                                          key={incident?.id}
                                          onClick={() =>
                                            selectedIncidentByID(
                                              incident?.id,
                                              incident?.current_inspection
                                                ?.status_text
                                            )
                                          }
                                        >
                                          <TableCell component="th" scope="row">
                                            <Box>
                                              <Box
                                                style={{
                                                  display: 'inline-block',
                                                  marginRight: '10px',
                                                }}
                                              >
                                                <Typography
                                                  component="span"
                                                  variant="h3"
                                                >
                                                  {IncidentsLabels[
                                                    incident?.incident_type
                                                  ] || incident?.incident_type}
                                                </Typography>
                                              </Box>
                                              <Box
                                                style={{
                                                  display: 'inline-block',
                                                }}
                                              >
                                                <Typography
                                                  style={{
                                                    display: 'inline-block',
                                                  }}
                                                >
                                                  Nº {incident?.number}
                                                </Typography>
                                                {incident?.current_inspection
                                                  ?.status_text ===
                                                'Pendiente de inspección' ? (
                                                  <img
                                                    src={redCheckImg}
                                                    alt={'checked'}
                                                    style={{
                                                      display: 'inline-block',
                                                      marginLeft: '8px',
                                                      marginBottom: '5px',
                                                    }}
                                                  ></img>
                                                ) : null}
                                              </Box>
                                            </Box>
                                            <Typography>
                                              {incident?.date
                                                ?.split('-')
                                                .reverse()
                                                .join('/')}
                                            </Typography>
                                            <Typography
                                              style={{ color: '#FA6400' }}
                                            >
                                              {
                                                incident?.current_inspection
                                                  ?.status_text
                                              }
                                            </Typography>
                                          </TableCell>

                                          <TableCell align="center">
                                            {incident?.item.license_plate ||
                                            incident.product.code === 4
                                              ? incident?.item.license_plate
                                              : incident?.product.description}
                                          </TableCell>

                                          <TableCell align="right">
                                            <RightIcon></RightIcon>
                                          </TableCell>
                                        </TableRow>
                                      </Fade>
                                    ))}
                                </TableBody>
                              </Table>
                            </TableContainer>
                          </Box>
                        )}
                      </>
                    </InfiniteScroll>
                  </div>
                ) : (
                  <InfiniteScroll
                    //This is important field to render the next data
                    dataLength={incidents?.pages?.flat().length}
                    next={handleNextPage}
                    hasMore={HandleMore()}
                    loader={
                      <Box style={{ width: '100%' }}>
                        <LinearProgress color="primary" />
                      </Box>
                    }
                    endMessage={
                      <Box m={2}>
                        <Typography
                          style={{ textAlign: 'center' }}
                          color="textSecondary"
                        >
                          Ya hemos mostrado todos los resultados
                        </Typography>
                      </Box>
                    }
                    height={matches ? 600 : null}
                  >
                    <>
                      {incidents && !incidents?.pages?.flat().length ? (
                        <Box my={4} textAlign="center">
                          {/* <img
                            className={classes.incidentsImg}
                            src={DenunciasIlus}
                            alt={'Denuncias'}
                          ></img> */}
                          <Typography variant="h6">
                            {' '}
                            ¡No tenés denuncias!{' '}
                          </Typography>
                          <Typography variant="body2">
                            {' '}
                            Cuando realices una denuncia vas a poder darle
                            seguimiento desde acá.{' '}
                          </Typography>
                        </Box>
                      ) : (
                        <Box my={2}>
                          <TableContainer component={Paper}>
                            <Table aria-label="incidents table">
                              <TableHead>
                                <TableRow>
                                  <TableCell> Denuncia </TableCell>
                                  <TableCell align="center">
                                    {' '}
                                    Patente{' '}
                                  </TableCell>
                                  <TableCell align="center"> </TableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {incidents?.pages
                                  ?.flat()
                                  .map((incident: any) => (
                                    <Fade in={true}>
                                      <TableRow
                                        hover
                                        key={incident?.id}
                                        onClick={() =>
                                          selectedIncidentByID(
                                            incident?.id,
                                            incident?.current_inspection
                                              ?.status_text
                                          )
                                        }
                                      >
                                        <TableCell component="th" scope="row">
                                          <Box>
                                            <Box
                                              style={{
                                                display: 'inline-block',
                                                marginRight: '10px',
                                              }}
                                            >
                                              <Typography
                                                component="span"
                                                variant="h3"
                                              >
                                                {IncidentsLabels[
                                                  incident?.incident_type
                                                ] || incident?.incident_type}
                                              </Typography>
                                            </Box>
                                            <Box
                                              style={{
                                                display: 'inline-block',
                                              }}
                                            >
                                              <Typography
                                                style={{
                                                  display: 'inline-block',
                                                }}
                                              >
                                                Nº {incident?.number}
                                              </Typography>
                                              {incident?.current_inspection
                                                ?.status_text ===
                                              'Pendiente de inspección' ? (
                                                <img
                                                  src={redCheckImg}
                                                  alt={'checked'}
                                                  style={{
                                                    display: 'inline-block',
                                                    marginLeft: '8px',
                                                    marginBottom: '5px',
                                                  }}
                                                ></img>
                                              ) : null}
                                            </Box>
                                          </Box>
                                          <Typography>
                                            {incident?.date
                                              ?.split('-')
                                              .reverse()
                                              .join('/')}
                                          </Typography>
                                          <Typography
                                            style={{ color: '#FA6400' }}
                                          >
                                            {
                                              incident?.current_inspection
                                                ?.status_text
                                            }
                                          </Typography>
                                        </TableCell>

                                        <TableCell align="center">
                                          {incident?.item.license_plate ||
                                          incident.product.code === 4
                                            ? incident?.item.license_plate
                                            : incident?.product.description}
                                        </TableCell>

                                        <TableCell align="right">
                                          <RightIcon></RightIcon>
                                        </TableCell>
                                      </TableRow>
                                    </Fade>
                                  ))}
                              </TableBody>
                            </Table>
                          </TableContainer>
                        </Box>
                      )}
                    </>
                  </InfiniteScroll>
                )}
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      )}
    </>
  );
};

export default ListIncidents;
